// import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { NgxColorsModule } from 'ngx-colors';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  NgbTooltipModule,
  NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';
import { UiKitCoreModule } from '../core/uikit-core.module';
import { AttachmentFieldComponent } from './attachment-field/attachment-field.component';
import { AutocompleteFieldComponent } from './autocomplete-field/autocomplete-field.component';
import { CheckFieldComponent } from './check-field/check-field.component';
import { CheckboxListFieldComponent } from './checkboxlist-field/checkboxlist-field.component';
import { ColorPickerFieldComponent } from './color-picker-field/color-picker-field.component';
import { DateFieldComponent } from './date-field/date-field.component';
import { FormFieldWrapperComponent } from './form-field-wrapper.component';
import { NumericFieldComponent } from './numeric-field/numeric-field.component';
import { RadioFieldComponent } from './radio-field/radio-field.component';
import { SelectFieldComponent } from './select-field/select-field.component';
import { SignatureFieldComponent } from './signature-field/signature-field.component';
import { TextFieldComponent } from './text-field/text-field.component';
import { TimeFieldComponent } from './time-field/time-field.component';
import { WeeklyAvailabilityComponent } from './weekly-availability/weekly-availability.component';
import { WeeklyHoursAvailabilityComponent } from './weekly-hours-availability/weekly-hours-availability.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbTypeaheadModule,
    UiKitCoreModule,
    NgbTooltipModule,
    NgxColorsModule,
  ],
  declarations: [
    FormFieldWrapperComponent,
    TextFieldComponent,
    AutocompleteFieldComponent,
    CheckFieldComponent,
    DateFieldComponent,
    NumericFieldComponent,
    SelectFieldComponent,
    AttachmentFieldComponent,
    WeeklyAvailabilityComponent,
    TimeFieldComponent,
    CheckboxListFieldComponent,
    RadioFieldComponent,
    WeeklyHoursAvailabilityComponent,
    SignatureFieldComponent,
    ColorPickerFieldComponent,
  ],
  exports: [
    TextFieldComponent,
    AutocompleteFieldComponent,
    CheckFieldComponent,
    DateFieldComponent,
    NumericFieldComponent,
    SelectFieldComponent,
    AttachmentFieldComponent,
    WeeklyAvailabilityComponent,
    TimeFieldComponent,
    CheckboxListFieldComponent,
    WeeklyHoursAvailabilityComponent,
    RadioFieldComponent,
    SignatureFieldComponent,
    ColorPickerFieldComponent,
    FormFieldWrapperComponent,
  ],
})
export class FormFieldsModule {}
